export default __webpack_public_path__ + "static/media/covered-storage-dryer-icon.f983bb80.svg";